// extracted by mini-css-extract-plugin
module.exports = {"title":"virtualAssistantPropertiesSection_title__2zRKL"};
    if(module.hot) {
      // 1790670295325
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  